import { ButtonProps, Button } from '@mui/material';
import PopupMenu, { PopupMenuProps } from './PopupMenu';

export interface ButtonMenuProps extends PopupMenuProps, Omit<ButtonProps, 'children'> {}

export const ButtonMenu: React.FC<ButtonMenuProps> = ({ items, row, children, ...buttonProps }) => (
  <PopupMenu items={items} row={row}>
    <Button {...buttonProps}>{children}</Button>
  </PopupMenu>
);
